<template>
  <v-responsive v-if="busy" aspect-ratio="1">
    <Loading :isLoading="busy" color="white" absolute />
  </v-responsive>
  <NoData v-else-if="items.length === 0" :no-data-text="noDataText" />
  <v-row v-else>
    <v-col cols="6" sm="4"
           v-for="(item, index) in items"
           :key="index"
    ><LibraryItem :item="item" /></v-col>
  </v-row>
</template>

<script>
import LibraryItem from './LibraryItem.vue'
export default {
  name: 'LibraryItemList',
  components: {
    LibraryItem
  },
  props: {
    busy: {
      type: Boolean
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    noDataText: {
      type: String
    }
  }
}
</script>
